import { makeForm } from './makeForm'
import { preProcessFormValues } from './preProcessFormValues'

// @dynamic
export const QuickForm = {
  makeForm,
  preProcessFormValues
}
